// MSAL Configuration for Azure AD authentication
// Update these values with your Azure AD app registration details

export const msalConfig = {
    auth: {
        // Get these from Azure Portal > Azure AD > App registrations > Your app
        clientId: process.env.REACT_APP_AZURE_CLIENT_ID || "YOUR_CLIENT_ID",
        authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_TENANT_ID || "YOUR_TENANT_ID"}`,
        // Always use the actual hostname the SPA was loaded from. The site is
        // served on multiple hostnames (the legacy *.azurestaticapps.net URL
        // and the custom domain roster.snakepit.com.au), and using a baked-in
        // env var means the bundle redirects to the wrong host whenever it is
        // loaded from the other one. Each hostname must be registered as an
        // SPA redirect URI in the Azure AD app registration.
        redirectUri: window.location.origin,
        postLogoutRedirectUri: window.location.origin
    },
    cache: {
        cacheLocation: "sessionStorage", // or "localStorage"
        storeAuthStateInCookie: false
    }
};

// Scopes for API access
export const loginRequest = {
    scopes: ["user.read"]
};

// API scope - update with your API's scope if needed
export const apiRequest = {
    scopes: ["api://YOUR_API_ID/access_as_user"]
};
